<template>
  <v-dialog v-model="internalVisible" max-width="600px">
    <v-card>
      <v-card-title class="headline">{{
        $t("devices.all_devices")
      }}</v-card-title>
      <v-card-text>
        <v-data-table
          :footer-props="{
            'items-per-page-options': dataTableOptions,
          }"
          :headers="dataHeader"
          :hide-default-footer="true"
          :items="allDevices"
          :items-per-page="10000"
          class="elevation-0"
          style="width: 100%"
        >
          <template v-slot:item="{ item }">
            <tr @click="notifyPopUp(item)">
              <!-- <td>
                {{ item.id }}
              </td> -->
              <td>
                {{ item.name }}
              </td>
              <!-- <td>
                {{ item?.work_point?.address?.human_readable_address }}
              </td> -->
              <td>
                <v-icon color="orange" right @click.stop="notifyPopUp(item)">
                  mdi-bell-ring
                </v-icon>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pr-2">
        <v-spacer></v-spacer>
        <v-btn color="grey lighten-2" @click="close()">
          {{ $t("attachment.close") }}
          <v-icon dark right> mdi-close </v-icon>
        </v-btn>
      </v-card-actions>
      <confirmation-model
        v-if="confirmationDialog"
        :showDialog.sync="confirmationDialog"
        :openedForOperation.sync="confirmationDialogOperation"
        :text.sync="confirmationDialogConfirmationText"
        :checkboxText.sync="confirmationDialogReCheckBoxConfirmationText"
        :trueText.sync="confirmationDialogTrueText"
        :falseText.sync="confirmationDialogFalseText"
        @buttonClicked="confirmationButtonClicked"
      ></confirmation-model>
    </v-card>
  </v-dialog>
</template>

<script>
import { DEFAULT_ITEMS_PER_PAGE_OPTIONS } from "@/config";
import axios from "@/plugins/axios";
import { API_BASE_URL } from "@/config";
import ConfirmationModel from "@/components/ConfirmationModel";

export default {
  name: "SignaturePadModal",
  props: {
    value: Boolean, // v-model compatibility
    modelData: Object
  },
  emits: ["input"],
  components: {
    "confirmation-model": ConfirmationModel,
  },
  data() {
    return {
      pad: null,
      internalVisible: this.value,
      dataTableOptions: DEFAULT_ITEMS_PER_PAGE_OPTIONS,
      dataHeader: [
        // {
        //   text: "",
        //   align: "right",
        //   width: "10px",
        //   sortable: false,
        //   value: "information",
        // },
        {
          text: this.$t("devices.name"),
          align: "start",
          sortable: true,
          value: "name",
        },
        // {
        //   text: this.$t("devices.location"),
        //   align: "start",
        //   sortable: false,
        //   value: "location",
        // },
        {
          text: "",
          align: "right",
          width: "10px",
          sortable: false,
          value: "information",
        },
      ],
      selectedDevice: null,

      confirmationDialog: false,
      confirmationDialogConfirmationText: null,
      confirmationDialogReCheckBoxConfirmationText: null,
      confirmationDialogFalseText: null,
      confirmationDialogTrueText: null,
      confirmationDialogButtonClickedIs: null,
      confirmationDialogOperation: null,
    };
  },
  computed: {
    allDevices() {
      return this.$store.state.allDevices ?? [];
    },
  },
  watch: {
    value(val) {
      this.internalVisible = val;
    },
    internalVisible(val) {
      this.$emit("input", val);
    },
    confirmationDialogButtonClickedIs(newVal) {
      if (newVal == true && this.confirmationDialogOperation != null) {
        if (
          this.confirmationDialogOperation == "notify" &&
          this.confirmationDialogButtonClickedIs == true
        ) {
          this.notifyDevice();
        }
        this.confirmationDialog = false;
        this.confirmationDialogButtonClickedIs = null;
      }
    },
  },
  mounted() {
    this.confirmationDialog = false;
    this.confirmationDialogConfirmationText = null;
    this.confirmationDialogReCheckBoxConfirmationText = null;
    this.confirmationDialogFalseText = null;
    this.confirmationDialogTrueText = null;
    this.confirmationDialogButtonClickedIs = null;
    this.confirmationDialogOperation = null;
  },
  methods: {
    close() {
      this.$emit("input", false);
    },
    notifyDevice() {
      if (this.selectedDevice) {
        axios
          .post(API_BASE_URL + "/notify/device/" + this.selectedDevice.id, this.modelData, {
            headers: this.header,
          })
          .then(() => {})
          .catch((err) => {
            console.log("image", err);
          })
          .finally(() => {
            this.selectedDevice = null;
            this.close();
          });
      }
    },
    confirmationButtonClicked(buttonClicked) {
      this.confirmationDialogButtonClickedIs = buttonClicked;
      this.confirmationDialog = false;
    },
    notifyPopUp(item) {
      this.selectedDevice = item;
      this.confirmationDialogConfirmationText = this.$t(
        "devices.notify_confirmation"
      );
      this.confirmationDialogFalseText = this.$t("articles.cancel");
      this.confirmationDialogTrueText = this.$t("yes");
      this.confirmationDialogOperation = "notify";
      this.confirmationDialog = true;
    },
  },
};
</script>
<style scoped>
canvas {
  cursor: pointer;
  border: 2px solid black;
}

canvas:active {
  cursor: pointer;
}
</style>
